import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { UseCreateFromScratchReportModalProvider } from 'components/Dashboards/Reporting/CreateFromScratchReportModal/CreateFromScratchReportModal.provider';
import { getInitialLayout } from 'components/Dashboards/Reporting/reporting.utils';

interface Props {
    api: UseCreateFromScratchReportModalProvider['api'];
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

interface FormValues {
    reportName: string;
}

export const useCreateFromScratchReportModalLogic = ({ api, setIsModalOpen }: Props) => {
    const history = useHistory();
    const { handleSnackBar } = useCustomSnackBar();
    const form = useForm<FormValues>({
        defaultValues: {
            reportName: '',
        },
    });

    const hideModal = () => {
        setIsModalOpen(false);
    };

    const onNavigateToReport = (reportId: string) => {
        const url = AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH, reportId);
        history.push(url);
    };

    const onCreateReport = (formValues: FormValues) => {
        // reportName will be a string of 2-20 chars always since useForm is validating it
        const reportName = formValues.reportName;

        const emptyGridLayout = getInitialLayout();
        api.setReport.instance.mutate(
            { name: reportName, gridLayout: emptyGridLayout },
            {
                onSuccess: (response) => {
                    const reportId = response.id?.toString();
                    if (reportId) {
                        api.queryClient.invalidateQueries('getReportList');
                        handleSnackBar('New report created successfully', 'success');
                        onNavigateToReport(reportId);
                    }
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    return {
        logic: {
            hideModal,
            onNavigateToReport,
            onCreateReport,
            form,
        },
    };
};
